import { legalLinkClass } from './LegalText'
import { supportEmail, supportPhoneDisplay, termsLastUpdated } from '@/lib/legal'

/** The express acceptance of the terms a contracting dialog asks for; its confirm stays disabled until it is checked. */
export function TermsConsent({ checked, disabled, onChange }: { checked: boolean; disabled?: boolean; onChange: (checked: boolean) => void }) {
  return <label className="checkbox-field terms-consent">
    <input type="checkbox" checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} />
    <span>He leído y acepto los <a href="/terminos-y-condiciones" target="_blank" rel="noreferrer" className={legalLinkClass}>Términos y condiciones</a> (versión del {termsLastUpdated}).</span>
  </label>
}

/** Where to ask before contracting, and to cancel afterwards. */
export function SupportLine() {
  return <p className="dialog-note">Dudas o cancelaciones: {supportEmail} · <span className="whitespace-nowrap">{supportPhoneDisplay}</span></p>
}
